import { AspectRatio, AspectRatioProps, Image } from '@chakra-ui/react';
import { useMemo } from 'react';
import config from '../constants/config';
import ImageSize from '../types/imageSize';
import { generateRandomInteger } from '../utils/numberUtils';

type FancyBearImageProps = Omit<AspectRatioProps, 'ratio'> & {
  tokenId?: number;
  size?: ImageSize;
  isDisabled?: boolean;
};

const FancyBearImage = ({
  tokenId,
  size = '512',
  isDisabled = false,
  ...rest
}: FancyBearImageProps) => {
  const cacheId = useMemo(() => generateRandomInteger(1, 100), []);

  return (
    <AspectRatio
      ratio={1}
      w="full"
      bg="dark.400"
      borderRadius="md"
      overflow="hidden"
      {...rest}
    >
      <Image
        src={
          tokenId !== undefined
            ? `${config.urls.fancyBearsImagesUrl}/${
                size !== 'original' ? `${size}/` : ''
              }${tokenId}.png?v=${cacheId}`
            : undefined
        }
        fit="cover"
        opacity={isDisabled ? 0.5 : 1}
        transition="opacity 0.15s"
      />
    </AspectRatio>
  );
};

export default FancyBearImage;
